import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { EaSimulationPerPackFormComponent } from '@app/forms/simulation/ea-simulation-per-pack-form/ea-simulation-per-pack-form.component';
import * as _ from 'lodash';
import { of, map, mergeMap } from 'rxjs';
import {
  Allocation,
  PackService,
  SimulationPack,
} from '../simulation-pack.service';

export class PerPackService implements PackService {
  constructor(private simulationDao: SimulationDao) {}
  type = 'per';
  template = {
    panelTitle: 'Choisissez votre pack performant',
    tableTitle: 'Liste des supports',
    tableButtonText: 'Constituer mon allocation sur mesure',
    tableEmptyText: 'Allocation vide',
    tableAdjusmentText:
      'La répartition a été ajustée au plus proche de la répartition que vous désiriez',
  };

  customPack: SimulationPack = {
    name: 'Selection Manuelle',
    description:
      'Constituez vous-même votre allocation PER en choisissant vos supports parmis les meilleurs ',
    allocation: [],
    buttonText: 'Constituer mon allocation sur mesure',
  };

  packForm: any = EaSimulationPerPackFormComponent;

  getPacks(productId) {
    return this.simulationDao.getAuthentified().pipe(
      mergeMap(user => {
        if (!productId) return of([]);
        return this.simulationDao.getProductPacks('PER', productId).pipe(
          map(packs => {
            return _.map(packs, pack => {
              return {
                ..._.omit(pack, 'supportList'),
                id: pack.allocationModelId,
                allocation: _.map(pack.supportList, allocation => {
                  return {
                    allocationPercentage: allocation.allocationPercentage,
                    name: allocation.name || '',
                    supportIsin: allocation.isinCode,
                  } as unknown as Allocation;
                }),
              };
            });
          }),
        );
      }),
    );
  }
}
